import React from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from '../../textStyles.scss';

const Content = () => (
  <Well>
    <div className={styles.layout}>
      <h2 className={styles.header}>
        Achievable includes <b>10+ full-length GRE practice exam sections</b>
      </h2>

      <p>
        Achievable&apos;s GRE practice exams are a good estimate of your actual exam
        score. Our quantitative exam sections are generated from our exam question bank of{' '}
        <b>over 150 question templates</b>, with similar topic weightings and phrasing
        that you can expect on the actual exam. Our reading comprehension questions and
        essay prompts are carefully handwritten and include all the types of questions
        you&apos;ll see on the exam: reading comprehension, text completion, and sentence
        equivalence.
      </p>

      <p>
        Achievable uses dynamic question templates to create multiple unique versions of a
        question. We intelligently randomize the question prompt, answer, distractors, and
        explanation. A single question template can have hundreds of variations, ensuring
        that you thoroughly understand the concept and aren&apos;t just remembering an
        answer you&apos;ve seen previously.
      </p>
    </div>
  </Well>
);

export default Content;
